// eslint-disable-next-line import/prefer-default-export
export const REALJOBS = ['dashboard.realjobs.net', 'partner.realjobs.net'];
export const PTPIO = ['dashboard.ptp.io', 'partner.ptp.io'];
